import dayjs from 'dayjs';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Setting } from '../App';
import { useSubscriptionLineEditProduct } from '../hooks/use-subscription-line-edit-product';
import { calculateChangeDeadline } from '../utils/calculateChangeDeadline';

export const SubscriptionLineEditProduct: FC<{ setting: Setting }> = ({ setting }) => {
  const { subscription, products, lineId, infoMessage, page, hasNextPage, paginate } = useSubscriptionLineEditProduct(setting);

  if (!subscription) {
    return <></>;
  }

  const actionType = lineId === 'new' ? '追加' : '変更';

  if (subscription!.shop.isAllowModifyDays) {
    const limitDate = calculateChangeDeadline(subscription!);
    if (dayjs().isAfter(limitDate)) {
      return (
        <>
          <h2>商品の{actionType}</h2>
          <p>
            商品の{actionType}は次回ご注文日の{subscription!.shop.allowModifyDays}日前以降はご利用できません。
            <br />
            次回のご注文日、【{dayjs(subscription!.nextBillingDate).format('YYYY/MM/DD')}
            】以降にご利用が可能となります。
          </p>
          <div className="huckleberry-subscription-product-edit back">
            <Link to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}>戻る</Link>
          </div>
        </>
      );
    }
  }

  if (!products || products.length === 0) {
    return (
      <>
        <p
          dangerouslySetInnerHTML={{
            __html: infoMessage,
          }}
        />
        {subscription ? (
          <div className="huckleberry-subscription-product-edit back">
            <Link to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}>戻る</Link>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }

  let prevPageHtml = <></>;
  if (page > 0) {
    prevPageHtml = <div onClick={() => paginate(page - 1)}>前のページへ</div>;
  }

  let nextPageHtml = <></>;
  if (hasNextPage) {
    nextPageHtml = <div onClick={() => paginate(page + 1)}>次のページへ</div>;
  }

  const alternativeProducts = products.filter((product) => {
    // 商品のバリエーション全てが定期購買に登録済み
    if (
      product.variants.every((variant) => subscription.subscriptionLines.some((line) => line.variantId === variant.variantId))
    )
      return false;

    // 商品のバリエーション全てが、配送あり定期購買で配送なし商品、または配送なし定期購買で配送あり商品
    if (
      product.variants.every(
        (variant) =>
          (variant.requiresShipping && !subscription.deliveryCountryCode) ||
          (!variant.requiresShipping && !!subscription.deliveryCountryCode),
      )
    )
      return false;

    return true;
  });

  if (alternativeProducts.length === 0 && page === 0) {
    return (
      <>
        <p
          dangerouslySetInnerHTML={{
            __html: 'この商品は変更できません。<br/>店舗にお問い合わせください。',
          }}
        />
        {subscription ? (
          <div className="huckleberry-subscription-product-edit back">
            <Link to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}>戻る</Link>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }

  return (
    <>
      <h2>商品の{actionType}</h2>
      <p>次回、ご注文の商品を{actionType}します。下記の商品から選択してください。</p>

      <div className="huckleberry-subscription-product-edit product">
        {alternativeProducts.map((product, pidx) => {
          return (
            <div className="item" key={pidx}>
              <main>
                <figure>
                  <img src={product.images.length > 0 ? product.images[0] : ''} alt="" />
                </figure>
                <p className="title">{product.title}</p>
              </main>
              <footer>
                <Link
                  className="select"
                  to={`/subscriptions/${encodeURIComponent(
                    subscription!.subscriptionContractId,
                  )}/products/${encodeURIComponent(product.productId)}/lines/${encodeURIComponent(lineId)}`}
                >
                  選択
                </Link>
              </footer>
            </div>
          );
        })}
      </div>
      <div className="huckleberry-subscription-product-edit pagination">
        {prevPageHtml}
        {nextPageHtml}
      </div>
      <div className="huckleberry-subscription-product-edit back">
        <Link to={`/subscriptions/${encodeURIComponent(subscription!.subscriptionContractId)}`}>戻る</Link>
      </div>
    </>
  );
};
